/** TanStack Query wrappers for the consent gate. */

import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import type {
  ConsentStatusResponse,
  PolicyAcceptance,
} from "@patent-studio/api-types";
import { acceptPolicies, getConsentStatus } from "@/services/consent";
import { CONSENT_KEY } from "./query-keys";
import { MUTATION_KEYS } from "@/lib/analytics/mutation-reporting";

export function useConsentStatus() {
  return useQuery({
    queryKey: CONSENT_KEY,
    queryFn: getConsentStatus,
    // The gate stands in front of the whole app, so a stale "nothing
    // outstanding" would let a user past a policy that has since moved. Read it
    // fresh on every mount rather than serving it from cache.
    staleTime: 0,
  });
}

export function useAcceptPolicies() {
  const qc = useQueryClient();
  return useMutation({
    mutationKey: MUTATION_KEYS.policiesAccept,
    mutationFn: (acceptances: PolicyAcceptance[]) =>
      acceptPolicies(acceptances),
    onSuccess: (data: ConsentStatusResponse) => {
      // The server returns the updated status, so the gate can lift without a
      // second round trip.
      qc.setQueryData(CONSENT_KEY, data);
    },
  });
}
